import { render, staticRenderFns } from "./ManualEmissions.vue?vue&type=template&id=5db2af8c&"
import script from "./ManualEmissions.vue?vue&type=script&lang=ts&"
export * from "./ManualEmissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports